class VariantDropdownFilter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.filterInput = this.querySelector('.variant-filter-input');
    this.dropdownItems = this.querySelectorAll('.variant-dropdown-item');
    this.dropdownList = this.querySelector('.variant-dropdown-list');
    this.dropdownToggle = this.querySelector('.variant-dropdown-toggle');
    this.selectedValue = this.querySelector('.selected-value');
    
    if (this.filterInput) {
      this.filterInput.addEventListener('input', this.filterOptions.bind(this));
    }
    
    if (this.dropdownToggle) {
      this.dropdownToggle.addEventListener('click', this.toggleDropdown.bind(this));
    }
    
    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    });
    
    // Add click event to each dropdown item
    // Note: Out of stock items (valid variants with 0 inventory) should still be selectable
    // so users can click "Notify me when Available"
    this.dropdownItems.forEach(item => {
      item.addEventListener('click', () => {
        const input = item.querySelector('input[type="radio"]');
        const label = item.querySelector('label');
        
        // Allow selection of all items including out of stock ones
        // This allows users to select out of stock variants and see "Notify me when Available"
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Update selected value display - get just the variant name without "Out of Stock" badge
          if (this.selectedValue && label) {
            // Get just the value name, not the "Out of Stock" badge text
            const valueText = input.value || label.textContent.split('Out of Stock')[0].trim();
            this.selectedValue.textContent = valueText;
            
            // Add visual indicator to selected value if out of stock (valid variant but no inventory)
            const isOutOfStock = item.getAttribute('data-out-of-stock') === 'true' || 
                                 input.getAttribute('data-out-of-stock') === 'true';
            if (isOutOfStock) {
              this.selectedValue.classList.add('selected-out-of-stock');
            } else {
              this.selectedValue.classList.remove('selected-out-of-stock');
            }
          }
          
          this.closeDropdown();
        }
      });
    });
  }
  
  filterOptions() {
    const filterValue = this.filterInput.value.toLowerCase();
    
    this.dropdownItems.forEach(item => {
      const label = item.querySelector('label');
      if (label) {
        const text = label.textContent.toLowerCase();
        if (text.includes(filterValue)) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      }
    });
  }
  
  toggleDropdown() {
    if (this.dropdownList.classList.contains('active')) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }
  
  openDropdown() {
    this.dropdownList.classList.add('active');
    this.classList.add('active');
    
    // Focus on filter input when dropdown opens
    if (this.filterInput) {
      setTimeout(() => {
        this.filterInput.focus();
      }, 10);
    }
  }
  
  closeDropdown() {
    this.dropdownList.classList.remove('active');
    this.classList.remove('active');
    
    // Clear filter when dropdown closes
    if (this.filterInput) {
      this.filterInput.value = '';
      this.filterOptions();
    }
  }
}

customElements.define('variant-dropdown-filter', VariantDropdownFilter); 